<template>
<div>
    <div  class="media">
      <div @dblclick="editModus = true" class="media-body">
        <div class="media">
          <div class="media-left media-middle" :title="KomboxConf.TYPES[kombox.type].SYMBOL.TITLE">
              <span class="glyphicon" v-bind:class="[KomboxConf.TYPES[kombox.type].SYMBOL.CLASS, KomboxConf.ACLS[kombox.acl].SYMBOL.CLASS]"></span>
          </div>

          <div class="media-body cc-kombox-body  media-middle" >
              <strong v-if="kombox.acl == 3" :title="kombox.content">*******</strong>
              <strong v-else>{{kombox.content}}</strong>

              <small>{{kombox.description}}</small>
          </div>
        </div>
      </div>    

      <div class="media-right text-right media-middle">
          <button v-show="true" 
                  type="button" class="btn btn-xs btn-default" 
                  v-bind:class="{'btn-success': shippingAktive}" 
                  v-on:click="onClickShipping">
                  <span class="glyphicon glyphicon-send"></span>
          </button>
      </div>
    </div>
</div>

</template>



<script>

import bus from './common/bus'
import * as KomboxConf from './common/kombox.conf'


export default {
  
  
  components: {
  },
  
  props: {
    kombox: {}
  },
      
  
  data () {
    return {
      KomboxConf: KomboxConf,
      shippingAktive: false,
    }
  },
  
  created: function () {
  },
  
  
  methods: {
    
    onClickShipping: function () {
      this.emitShipping(!this.shippingAktive, this.kombox);
    },
    
    emitShipping: function (shippingState, kombox) {
      if(this.shippingAktive != shippingState){
        this.shippingAktive = shippingState;
        if(shippingState){
          this.$emit('add-shipping', kombox);
        }else{
          this.$emit('remove-shipping', kombox);
        }
      }
    },

    
  }
  
}
</script>



<style scoped>

  small{
    color: gray;
  }
  
.acl-public{
    color: gray;
  }
  
  .acl-intern{
    color: #dacd00;
  }

  .acl-privat{
    color: #be0000;
  }

  .btn{
    padding: 4px 10px;
  }
  
  .cc-btn-menue{
    padding-left: 10px;  
    padding-right: 0px;  
  }
  
  .media-right{
    min-width: 100px;
  }

  .media-left{
    padding-left: 15px;
  }
  
  .cc-kombox-typ{
    padding-bottom: 30px;
  }
  
  .cc-kombox-body{
    color: gray;
    border-left: 0px solid red;
    padding-left: 8px;
    line-height: 1.1em;
    min-width: 120px;
  }
  
.media-left .glyphicon {
    padding-right: 0px;
    font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// KomboxUserCallerColleague.vue?bc2beefa